<template>
    <div>

        <div class="ix-table-box">
            <table class="ix-table ix-table-sm ix-table-bordered">
                <thead>
                    <tr>
                        <th colspan="2"></th>
                        <th>Échues</th>
                        <th colspan="6">Non Échues</th>
                        <th class="text-right">Total</th>
                        <th></th>
                    </tr>
                    <tr>
                        <th colspan="2"></th>
                        <th class="text-right" style="color: white; background: #000000">> 0 j</th>
                        <th style="background: #ef5519; " class="text-right">0 - 30 j</th>
                        <th style="background: #f17f05;" class="text-right">31 - 60 j</th>
                        <th style="background: #f8cb88;" class="text-right">61 - 90 j</th>
                        <th style="background: #ffedd1;" class="text-right">91 - 120 j</th>
                        <th style="background: #f6f8fa;" class="text-right">+ 120 j</th>
                        <th class="text-right">Total retard</th>
                        <th class="text-right">Total encours</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                    <td><strong>Fournisseur</strong></td>
                    <td><strong>Date limite de paiement</strong></td>
                    <template v-if="loading.totals == false">
                        <td class="text-right" v-for="total in totals">
                            <strong>{{ currency(total) }}</strong>
                        </td>
                    </template>
                    <template v-if="loading.totals == true">
                        <td colspan="9" class="text-center">
                            <i class="far fa-circle-notch fa-spin"></i>
                        </td>
                    </template>
                </tr>
                </tbody>
                <template v-for="row in companies">
                    <tbody>
                        <tr>
                            <td colspan="2">
                                <a v-bind:href="row.company.route" class="ix-link">{{ row.company.name }}</a>
                            </td>
                            <td class="text-right">{{ currency(row.amount.not_due) }}</td>
                            <td class="text-right" v-for="total in row.amount.due">
                                {{ currency(total) }}
                            </td>
                            <td class="text-right">{{ currency(row.amount.total_due) }}</td>
                            <td class="text-right">{{ currency(row.amount.total_remaining) }}</td>
                            <td class="text-right">
                                <span class="btn btn-sm transparent" v-on:click="row.company.open = !row.company.open">
                                    <i class="far fa-chevron-up" v-if="row.company.open"></i>
                                    <i class="far fa-chevron-down" v-if="!row.company.open"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-if="row.company.open">
                        <tr v-for="bill in row.bills" class="ix-table-row-secondary">
                            <td>
                                <a v-bind:href="bill.route">{{ bill.full_designation }}</a>
                            </td>
                            <td>{{ bill.due_at }}</td>
                            <td class="text-right">
                                <span v-if="bill.gap < 0">{{ currency(bill.total_remaining) }}</span>
                            </td>
                            <td class="text-right">
                                <span v-if="bill.gap >= 0 && bill.gap <= 30">{{ currency(bill.total_remaining) }}</span>
                            </td>
                            <td class="text-right">
                                <span v-if="bill.gap >= 31 && bill.gap <= 60">{{ currency(bill.total_remaining) }}</span>
                            </td>
                            <td class="text-right">
                                <span v-if="bill.gap >= 61 && bill.gap <= 90">{{ currency(bill.total_remaining) }}</span>
                            </td>
                            <td class="text-right">
                                <span v-if="bill.gap >= 91 && bill.gap <= 120">{{ currency(bill.total_remaining) }}</span>
                            </td>
                            <td class="text-right">
                                <span v-if="bill.gap > 120">{{ currency(bill.total_remaining) }}</span>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </template>
                <tbody v-if="loading.table == true && companies.length == 0">
                <tr>
                    <td colspan="2">Récupération des données en cours</td>
                    <td colspan="9" class="text-center">
                        <i class="far fa-circle-notch fa-spin"></i>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="ix-table-bottom">
            <div class="ix-table-bottom-left"></div>
            <div class="ix-table-bottom-center"></div>
            <div class="ix-table-bottom-right">
                <button class="ix-btn ix-btn-sm transparent" v-on:click="getTable(page + 1)" v-if="page !== null && page < pages" :disabled="loading.table">
                    <span v-if="loading.table == false">Afficher plus d'éléments</span>
                    <i v-if="loading.table == true" class="far fa-circle-notch fa-spin"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            routeTotals : String,
            routeTable : String,
            companyIds : String
        },
        data() {
            return {
                loading: {
                    totals: true,
                    table: true,
                },
                totals: [],
                companies: [],
                page: 1,
                pages : 0,
            };
        },
        methods : {
            getTotals : async function(){
                this.loading.totals = true;
                fetch(this.routeTotals + (this.companyIds ? '?company_id=' + this.companyIds : ''), {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.totals = data.totals
                    this.loading.totals = false;
                }).catch(error => {
                    console.log(error)
                });
            },
            getTable : async function(page){
                this.loading.table = true;
                fetch(this.routeTable + '?page=' + page + (this.companyIds ? '&company_id=' + this.companyIds : ''), {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.page = page
                    this.companies = this.companies.concat(data.data);
                    this.pages = data.pages;
                    this.loading.table = false;
                }).catch(error => {
                    console.log(error)
                });
            },
        },
        async mounted() {
            await this.getTotals();
            await this.getTable(1);
        }
    }
</script>
